/**************************************************************************
 * Created on Fri Nov 22 2024
 *
 *  # Honeywell Code Usage Policy
 *
 * **Honeywell Source Code Usage Policy Classification:** Highly Confidential
 *
 * [comment]: # (Options for above are "Inner Source", "General Application", "Highly Confidential", "Export Controlled")
 *
 * **This repository has multiple classifications:** Yes
 *
 * [comment]: # (Options for above are "Yes" when subfolders contain a separate policy,"No" when the whole repo has the same policy)
 *
 * **Honeywell confidential - For internal use only.
 *
 * Property of and copyright ownership by Honeywell International Inc. and/or its affiliates.
 *
 * Use of source code must follow all Honeywell policies including the [HCE Source Code Access Policy](http: //go.honeywell.com/hce-code-access-policy).
 *
 * External use or distribution prohibited without written approval per Honeywell policies**
 *
********************************************************************************/

export const CMS = 'cms';
export const COM_API = `${CMS}/api`;
export const SLIDE = 'dss-slides';
export const LATEST_NEWS = 'ads-nav-databases';
export const PRODUCT = 'inds-products';
export const TOOLS = 'inds-tools';
export const ABOUTS = 'dss-abouts';
export const FEATURES = 'dss-features';
export const OFFERING = 'offerings';
export const UPCOMMING_EVENT = 'dss-upcoming-events';
export const FAQ = 'dss-faqs';
export const NEWSLETTER = 'banner-slider-adss';
export const LATEST_UPDATE = 'inds-latest-newss';
export const CUSTOMER_SUPPORT = 'inds-supports';
export const ONLINE_HELP = 'inds-online-helps';
export const ONLINE_HELP_PARAMS = 'AircraftList,Category,Category.subcategory';
export const QUALITY_DOCUMENTS = 'inds-qualitydocuments';
export const SLIDES = 'inds-slide';
export const MAIN_EVENTS = 'inds-main-events';
export const SUB_EVENTS = 'inds-sub-event';
export const CALENDAR_EVENTS = 'inds-events-calendars';
export const INDS_CALENDAR = 'inds-calendars';
export const INDS_ALERTS = 'inds-alerts';
export const ALL_UPDATES = 'inds-news';
export const INDS_BROADCASTS = 'inds-broadcasts';


//@ts-ignore
export const CMS_URL = `${window.ENV.REACT_STRAPI_API ?? ''}/${CMS}`
//@ts-ignore
export const PRIMUS_ELITE_CONFIG_PDF = window.ENV.PRIMUS_ELITE_CONFIG_PDF ?? '';
//@ts-ignore
export const INDS_FAQ_PDF = window.ENV.INDS_FAQ_PDF ?? '';
//@ts-ignore
export const USER_GUIDE_TUTORIALS_URL = window.ENV.USER_GUIDE_TUTORIALS_URL ?? '';
//@ts-ignore
export const USER_GUIDE_EXTERNAL_URL = window.ENV.USER_GUIDE_EXTERNAL_URL ?? '';
//@ts-ignore
export const USER_GUIDE_INTERNAL_URL = window.ENV.USER_GUIDE_INTERNAL_URL ?? '';

export const PARAM_UPDATE = 'documents,children,children.subcontentdocuments,children.links';
//@ts-ignore
export const HOME_BASE_URL = window.ENV.REACT_STRAPI_API ?? "";
//@ts-ignore
export const SEARCH_URL = window.ENV.AERO_SEARCH_URL ?? "https://www.honeywellaerospace.com/us/en/search";


export const PARAM_CATALOG = 'Catalogs,Catalogs.links';
